'use strict';
module.exports = [
  '$scope',
  'keywordsService',
  '$state',
  '$timeout',
  'toastService',
  function ($scope, keywordsService, $state, $timeout, toastService) {
    $scope.keywordForm;

    $scope.hasPerms = function () {
      // return $stateParams.id ? $scope.jdroPerms.UPDATE : $scope.jdroPerms.CREATE;
      return true;
    };

    if ($state.params.id) {
      console.log($scope.keywordForm);
      keywordsService.getById({ id: $state.params.id }, function (response) {
        Object.assign($scope.keywordForm, response);
      });
    } else {
      $timeout(function () {
        Object.assign($scope.keywordForm, {
          active: true,
          comment: {
            comment: '',
            locale: 'IT',
          },
          type: 'SITUATION_RECORD',
          clazz: 'com.dromedian.jdro.datex2.domain.Keyword',
        });
      });
    }

    $scope.submit = function () {
      if (!$scope.keywordForm.valid && !$scope.keywordForm.comment.comment.trim()) {
        return;
      }

      if ($state.params.id) {
        keywordsService.update(
          $scope.keywordForm,
          function () {
            $state.go('situation-record-keyword-list');
          },
          function (error) {
            $scope.error = error.data;
          }
        );
      } else {
        keywordsService.create(
          {
            clazz: $scope.keywordForm.clazz,
            comment: $scope.keywordForm.comment.comment.trim(),
            type: $scope.keywordForm.type,
          },
          function () {
            toastService.createSuccessToast('Etichetta creata con successo');
            $state.go('situation-record-keyword-list');
          },
          function (error) {
            toastService.createErrorToast("Errore durante la creazione dell'etichetta");
            $scope.error = error.data;
          }
        );
      }
    };

    $scope.cancel = function () {
      $state.go('situation-record-keyword-list');
    };
  },
];



//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-AstralSituationRecord/components/keyword/keywordDetail/keywordDetailCtrl.js
// module id = 248
// module chunks = 0